var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8V2.50342C11 2.2329 10.7804 2 10.5095 2H7.49048C7.21506 2 7 2.22539 7 2.50342V8H3.50035C3.229 8 3.16 8.16 3.35736 8.35736L8.64264 13.6426C8.83951 13.8395 9.16 13.84 9.35736 13.6426L14.6426 8.35736C14.8395 8.16049 14.776 8 14.4997 8H11ZM17 17C17.5523 17 18 17.4477 18 18C18 18.5523 17.5523 19 17 19H1C0.447715 19 0 18.5523 0 18C0 17.4477 0.447715 17 1 17H17ZM10.5095 0C11.899 0 13 1.14166 13 2.50342V6H14.4997C16.5744 6 17.5021 8.32629 16.0569 9.77157L10.7716 15.0569C9.79303 16.0354 8.20622 16.0346 7.22843 15.0569L1.94315 9.77157C0.490457 8.31888 1.44066 6 3.50035 6H5V2.50342C5 1.13347 6.09727 0 7.49048 0H10.5095Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6b1ead037c0f5838fd6ed7784bca3119.svg";
export { ForwardRef as ReactComponent };